export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_complete_6.ab7a7cd3.jpg";